import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-broadband',
  templateUrl: './business-broadband.component.html',
  styleUrls: ['./business-broadband.component.css']
})
export class BusinessBroadbandComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
